import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse, HttpErrorResponse, HttpClient, HttpHeaders, } from '@angular/common/http';
import { Injectable, Inject, NgZone } from '@angular/core';
import { from, Observable, Subscriber, BehaviorSubject, Subject, Subscription, of } from 'rxjs';
import { map, mergeMap } from 'rxjs/operators';
// import 'rxjs/Rx';
// import 'rxjs/add/observable/interval';
// import { JwtHelperService } from '@auth0/angular-jwt';
import { Router } from '@angular/router';
import { throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { StorageKeys } from 'src/app/utils/enum';
import { environment } from 'src/environments/environment';
import * as CryptoJS from 'crypto-js';

import moment from "moment";
// import { stringify } from '@angular/compiler/src/util';
export interface DateRangeState {
    startDate: moment.Moment;
    endDate: moment.Moment;
    label?: string;
    tz?: string;
}

@Injectable()
export class AuthService {
    A: string = "frgrtyhyujhogdrt";
    B:string = "wdvfrtghyujkimlo";
    moment = moment;
    userToken: any;
    loading = false;
    fetchDeploymentName:BehaviorSubject<any> = new BehaviorSubject({});
    // public dateRangeObj: BehaviorSubject<any>;
    public dateRangeObj =
    new BehaviorSubject<any>({
        startDate: moment().subtract(15,'minutes'),
        endDate: moment(),
        label:'Realtime',
        tz: moment.tz.guess()
    });
    dateRange$ = this.dateRangeObj.asObservable();
    public timezone: BehaviorSubject<any> = new BehaviorSubject<any>(moment.tz.guess());
    public chartConfigType: BehaviorSubject<any>;
    public isgroupManger: BehaviorSubject<any>;
    public mapFilterObj: BehaviorSubject<any>;
    public deviceObj: BehaviorSubject<any>;
    public deviceObjDetailedReport: BehaviorSubject<any>;
    public eventObject: BehaviorSubject<any>;
    private testType: BehaviorSubject<any>
    public deviceIdObj: Observable<any>;
    public dateObj: Observable<any>;
    public groupmanger: Observable<any>;
    public mapObj: Observable<any>;
    public mapSub: Subject<any>;
    public mapFiltersObj: Observable<any>;
    public reloadMapData:Subject<any>;
    public mapReloadObservable:Observable<any>;
    // for page Name
    public pageData: BehaviorSubject<any>;
    public pageName: Observable<any>;
    public refreshdataany: BehaviorSubject<any>;
    public datarefresh: Observable<any>;
    public sendSubmitNotification = new Subject();
    deviceinfoDebounser: any;
    testConfigurationPopup = new Subject();
    public securityProfileFilter: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
    public securityRuleIdFilter: BehaviorSubject<string[]> = new BehaviorSubject<string[]>([]);
    public securityApplyTrigger = new Subject<void>();
    constructor(private http: HttpClient,
        private router: Router,
        @Inject('apiEndPoint') private apiEndPoint: string,
        @Inject('fileServerUrl') private fileServerUrl: string,
        // public jwtHelper: JwtHelperService,
        public zone: NgZone,) {
        this.userToken = localStorage.getItem(StorageKeys.TOKEN);
        let daterange = {
            'startDate': moment(), 'endDate': moment().add(5, 'minutes')
        }

        // for calling groupmanger model from the header button
        let isgroup: boolean = false;
        this.isgroupManger = new BehaviorSubject<any>(isgroup);
        this.groupmanger = this.isgroupManger.asObservable();


        this.mapFilterObj = new BehaviorSubject<any>('');
        this.mapFiltersObj = this.mapFilterObj.asObservable();
        
        this.reloadMapData = new Subject<any>();
        this.mapReloadObservable = this.reloadMapData.asObservable();

        // for getting date
        // this.dateRangeObj = new BehaviorSubject<any>(daterange);
        this.chartConfigType = new BehaviorSubject<any>('');

        // this.dateObj = this.dateRangeObj.asObservable();
        this.refreshdataany = new BehaviorSubject<any>('');
        this.datarefresh = this.refreshdataany.asObservable();

        this.deviceObj = new BehaviorSubject<any>([]);
        this.deviceIdObj = this.deviceObj.asObservable();

        this.deviceObjDetailedReport = new BehaviorSubject<any>([]);

        this.eventObject = new BehaviorSubject<any>([]);

        this.mapSub = new Subject<any>();
        this.mapObj = this.mapSub.asObservable();

        this.testType = new BehaviorSubject<any>('')

        this.pageData = new BehaviorSubject<any>(localStorage.getItem('pageNameTitle') ? localStorage.getItem('pageNameTitle') : 'Home');
        this.pageName = this.pageData.asObservable();

    }
    // getDateRangeObj(dateObj):any { 
    //         console.log("this",dateObj) 
    //     this.dateRangeObj.next(dateObj);
    // }
    refreshData() {
        this.refreshdataany.next('');
    }
    getRefreshData() {
       return this.datarefresh;
    }
    sendMessage(message) {
        this.dateRangeObj.next(message);
    }
    getCurrentDateRange() {
        return this.dateRangeObj.value;
    }

    sendTz(tz){
        this.timezone.next(tz);
    }
    getTz(){
        return this.timezone.asObservable();
    }
    sendChartConfig(message) {
        this.chartConfigType.next(message);
    }
    triggerModel(message) {  // for calling groupmanger model from the header button
        this.isgroupManger.next(message);
    }
    sendDeviceInfo(message) {
            this.deviceObj.next(message); 
    }

    sendDetailedReprotDeviceInfo(device){
        this.deviceObjDetailedReport.next(device);
    }

    getDetailedReprotDeviceInfo(){
       return this.deviceObjDetailedReport.asObservable();
    }

    sendEventInfo(message:any){
        this.eventObject.next(message);
    }
    

    sendMapInfo(map) {
        this.mapSub.next(map)
    }

    getDeviceInfo(where?:any): Observable<any> {
        // console.log(`get device info subscribed at ${where}`)
        return this.deviceObj.asObservable();
    }

    getEventType(): Observable<any> {
        return this.eventObject.asObservable();
    }

    sendMapFIlter(filter) {
        this.mapFilterObj.next(filter);
    }
    getMapFilterObj(): Observable<any> {
        return this.mapFilterObj.asObservable();
    }
    getDateRangeObj(): Observable<any> {
        return this.dateRangeObj.asObservable();
    }
    getPageNameData(pageName): any {
        localStorage.setItem('pageNameTitle', pageName)
        this.pageData.next(pageName);
    }
    sendTestType(type) {
        return this.testType.next(type)
    }

    getTestType() {
        return this.testType.asObservable()
    }

    sendSecurityProfileFilter(profiles: any[]) {
        this.securityProfileFilter.next(profiles);
    }
    getSecurityProfileFilter(): Observable<any[]> {
        return this.securityProfileFilter.asObservable();
    }
    sendSecurityRuleIdFilter(ruleIds: string[]) {
        this.securityRuleIdFilter.next(ruleIds);
    }
    getSecurityRuleIdFilter(): Observable<string[]> {
        return this.securityRuleIdFilter.asObservable();
    }
    triggerSecurityApply() {
        this.securityApplyTrigger.next();
    }



    isLoading() {
        return this.loading;
    }
    getUserDetails(){
        return this.http.get(`${this.apiEndPoint}/_me`);
    }
    updateUser(body, userName) {
        return this.http.put(this.apiEndPoint + '/_me', body);
    
      }
    getUserInfofromFB(id){
        return this.http.get(`${this.apiEndPoint}/_me/credentials/facebook`)
    }
    getRoleDetails(user_type: any){
        return this.http.get(this.apiEndPoint + '/gwdevice/configparam/' + user_type );
     
       }
    login(username: string, password: string) { 
        // login User and store the user details 
        let id = username;
        return this.http.post<any>(`${this.apiEndPoint}/_login/local?expiresIn=28800000`, { username, password })
            .pipe(map(user => {
                // console.log(user, 'useeeeeeeeeeeee')
                // localStorage.setItem('user', JSON.stringify(user));
                // this.userSubject.next(user);
                return user;
            }));
    }

    login_uibackend(username: string, password: string) {
        // login User and store the user details
        let id = username;
        return this.http.post<any>(`${this.fileServerUrl}/user/login`, { username, password })
            .pipe(map(user => {
                // console.log(user, 'useeeeeeeeeeeee')
                return user;
            }));
    }
    ldapLogin(username: string, password: string) {
        return this.http.post<any>(`${this.fileServerUrl}/user/login`, {
            username,
            password,           // encrypted
            loginType: 'ldap',  // tells the file server which Kuzzle strategy to use
        }).pipe(map(user => {
            return user;
        }));
    }
    fbLogin(code) {    
        return this.http.get<any>(`${this.apiEndPoint}/_login/facebook?code=${code}`)
            .pipe(map(user => {
                return user;
            }));
    }
    // https://production.viaviedge.net:8007/_login/local
    logout() {
        // remove user from local storage to log user out
        // localStorage.removeItem('user');
        // this.userSubject.next(null);
        this.router.navigate(['/login']);
    }
    postApiCall(api: any, data: any) {
        const headers = new HttpHeaders().set(StorageKeys.TOKEN, this.userToken);
        return this.http.post(this.apiEndPoint + api, data, { headers: headers })
            .pipe(
                catchError((err) => {
                    return throwError(JSON.stringify(err));    //Rethrow it back to component
                })
            )
    }
    postApiCallWithoutToken(api: any, data: any) {
        const headers = new HttpHeaders().set('istoken', 'false');
        return this.http.post(this.apiEndPoint + api, data, { headers: headers, observe: 'response' })
            .pipe(
                catchError((err) => {
                    return throwError(JSON.stringify(err));    //Rethrow it back to component
                })
            )
    }
    patchApiCall(api, data) {
        const headers = new HttpHeaders().set(StorageKeys.TOKEN, this.userToken);
        return this.http.patch(this.apiEndPoint + api, data, { headers: headers })
            .pipe(
                catchError((err) => {
                    return throwError(JSON.stringify(err));    //Rethrow it back to component
                })
            )
    }

    putApiCall(api, data) {
        const headers = new HttpHeaders().set(StorageKeys.TOKEN, this.userToken);
        return this.http.put(this.apiEndPoint + api, data, { headers: headers })
            .pipe(
                catchError((err) => {
                    return throwError(JSON.stringify(err));    //Rethrow it back to component
                })
            )
    }
    deleteApiCall(api) {
        const headers = new HttpHeaders().set(StorageKeys.TOKEN, this.userToken);
        return this.http.delete(this.apiEndPoint + api, { headers: headers })
            .pipe(
                catchError((err) => {
                    return throwError(JSON.stringify(err));    //Rethrow it back to component
                })
            )
    }

    getApiCall(api) {
        this.userToken = localStorage.getItem(StorageKeys.TOKEN);
        const headers = new HttpHeaders().set("Authorization", "Bearer " + this.userToken);
        return this.http.get(this.apiEndPoint + api, { headers: headers })
            .pipe(
                catchError((err) => {
                    return throwError(JSON.stringify(err));    //Rethrow it back to component
                })
            )
    }
    refreshToken(api: any, data: any) {
        this.userToken = localStorage.getItem(StorageKeys.TOKEN);
        const headers = { 'Content-Type': 'application/json' };
        return this.http.post(this.apiEndPoint + api, data, { headers: headers })
            .pipe(
                catchError((err) => {
                    return throwError(JSON.stringify(err));    //Rethrow it back to component
                })
            )
    }


    getFileApiCall(api) {
        const url = this.apiEndPoint + api;
        const cacheKey = url;
        const headers = new HttpHeaders().set(StorageKeys.TOKEN, this.userToken);
        return this.http.get(this.apiEndPoint + api, { headers: headers, observe: 'response' })
            .pipe(
                catchError((err) => {
                    return throwError(JSON.stringify(err));   //Rethrow it back to component
                })
            )
    }



    /*----- To handle error in http calls  ------ */
    public handleError(error: Response | any) {
        // switch (error.status) {
        //     case 0: {
        //         break;
        //     }
        //     case 401: {
        //     }
        //     case 403: {
        //     }
        //     default: {
        //         break;
        //     }
        // }
        //  return Observable.throwError(error);
    }

    getApiCallWithOutToken(api, data?) {
        const headers = new HttpHeaders().set('istoken', 'false');
        return this.http.get(this.apiEndPoint + api, { headers: headers })
            .pipe(
                catchError((err) => {
                    return throwError(JSON.stringify(err));   //Rethrow it back to component
                })
            )
    }

    refreshUserToken() {
        this.userToken = localStorage.getItem(StorageKeys.TOKEN);
    }

    public isAuthenticated(): boolean {
        const token = localStorage.getItem(StorageKeys.TOKEN);
        // return !this.jwtHelper.isTokenExpired(token);
        return true;
    }

    staticfileJson(file) {
        return this.http.get('assets/staticJsonFiles/' + file)
            .pipe(
                catchError((err) => {
                    return throwError(JSON.stringify(err));   //Rethrow it back to component
                })
            )
    }
    fileread(file) {
        return this.http.get(this.apiEndPoint + file)
            .pipe(
                catchError((err) => {
                    return throwError(JSON.stringify(err));   //Rethrow it back to component
                })
            )
    }



    getStaticApiCall(api) {
        return this.http.get(api)
            .pipe(
                catchError((err) => {
                    return throwError(JSON.stringify(err));   //Rethrow it back to component
                })
            )

    }

    getStaticJsonApiCall(api) {
        return this.http.get(api)
            .pipe(
                catchError((err) => {
                    return throwError(JSON.stringify(err));   //Rethrow it back to component
                })
            )

    }

    getCurrentUser() {
        return this.http.get(`${this.apiEndPoint}/_me`)
    }

    encryptUsingAES256(val:any) {
        let A = CryptoJS.enc.Utf8.parse(this.A);
        var iv = CryptoJS.enc.Utf8.parse(this.B)
        // console.log(this.A, iv);
        var encrypted = CryptoJS.AES.encrypt(val, A, 
            { iv: iv,
             padding: CryptoJS.pad.Pkcs7,
             mode: CryptoJS.mode.CBC
            }).ciphertext.toString(CryptoJS.enc.Base64);
        // encrypted =encrypted.toString();     
        return encrypted;
      }
  
     decrypt(encryptedText) { 
        // console.log(encryptedText) 
        var cipherParams = CryptoJS.lib.CipherParams.create({
          ciphertext: CryptoJS.enc.Base64.parse(encryptedText)
        });
        let A = CryptoJS.enc.Utf8.parse(this.A);
        var iv = CryptoJS.enc.Utf8.parse(this.B)
        let decrypt = CryptoJS.AES.decrypt(cipherParams, A, 
            { iv: iv,
            padding: CryptoJS.pad.Pkcs7,
             mode: CryptoJS.mode.CBC
            }).toString(CryptoJS.enc.Utf8);
            // console.log(decrypt, "is the decrypt of ", encryptedText);
        return decrypt;
      }

      getDeploymentName(){
        const filter = {"query":{"bool":{"must":[
            {"query_string":{ "query":"deployment_name", "type": "phrase", "fields": ["_id"] } }
          
        ]
           }},"sort":{"_kuzzle_info.createdAt":"desc"}}

        return this.http.post(`${this.apiEndPoint}/gwdevice/configparam/_search`, filter)
      }


    getConfigParam(name){
        const filter = {"query":{"bool":{"must":[
            {"query_string":{ "query":name, "type": "phrase", "fields": ["_id"] } }
          
        ]
           }},"sort":{"_kuzzle_info.createdAt":"desc"}}

        return this.http.post(`${this.apiEndPoint}/gwdevice/configparam/_search`, filter)
      }

      createLoginEvent(username:String, userid:any, time_utc:any, time_local_zone:any, user_type:any, event_type:any) {

        const filter = {
          username,
          userid,
          time_utc,
          time_local_zone,
          user_type,
          event_type
        }
        return this.http.post(`${this.apiEndPoint}/gwdevice/eventlog/_create`, filter)
      }

createLoginEventNotification(username:String, userid:any, time_utc:any, time_local_zone:any, user_type:any, event_type:any,event?:any, time_local?:any) {
        const filter = {
                    "status": "Login",
                     event_type,
                     event,
                    "read": false,
                    "message": `User, ${username}, logged in at ${time_local} in ${time_local_zone} timezone`,
                    "component": "User Login",
                     userid,
                     time_utc,
                     user_type,
                     username,
                     time_local_zone,
                     time_local
                    }
        return this.http.post(`${this.apiEndPoint}/gwdevice/eventnotification/_create`, filter)
      }


      getCurrentKuzzleTime() {
        return this.http.get(`${this.apiEndPoint}/_now`)
      }


}
